import { render, staticRenderFns } from "./evento-abierto.vue?vue&type=template&id=215bd4c1&scoped=true"
import script from "./evento-abierto.vue?vue&type=script&lang=js"
export * from "./evento-abierto.vue?vue&type=script&lang=js"
import style0 from "./evento-abierto.vue?vue&type=style&index=0&id=215bd4c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215bd4c1",
  null
  
)

export default component.exports